module.exports = __webpack_public_path__ + "img/439e8e0.svg";